import lozadInitiator from "../global/lozadInitiator";
import animations from "../global/animations";
import modals from "../global/modals";
import {throttle} from "../global/helpers";

const archiveAjax = {
    init() {
        const filtersForm = document.getElementById('filters-form');

        if (filtersForm !== null) {
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams) {
                for(const [key, value] of searchParams.entries()) {
                    const input = document.querySelector(`#${key}`);
                    if (input) {
                        input.value = decodeURI(value);
                    }
                }
            }

            var selects = {};
            var inputs = {};
            var radios = {};
            var checkboxes = {};

            let inputEls = document.querySelectorAll('.input-filter');
            let selectEls = document.querySelectorAll('.select-filter');
            let radiosEls = document.querySelectorAll('.radio-filter');
            let checkboxEls = document.querySelectorAll('.checkbox-filter');
            let loadMoreEls = document.querySelectorAll('.load-more');
            let eventsFilters = document.getElementById('events-filters');

            updateInputs(inputEls);
            updateSelects(selectEls);
            updateRadios(radiosEls);
            updateCheckboxes(checkboxEls);
            initializeLoadMores(loadMoreEls);

            filterPosts(selects, inputs, radios, checkboxes);

            document.querySelectorAll('.reset-filters').forEach(function(filter) {
                filter.onclick = function(evt){
                    evt.preventDefault();

                    filtersForm.reset();
                    for(var i=0;i<radiosEls.length;i++)
                        radiosEls[i].checked = i === 0;
                    for(var i=0;i<inputEls.length;i++)
                        inputEls[i].value = '';

                    selects = {};
                    inputs = {};
                    radios = {};
                    checkboxes = {};

                    filterPosts(selects, inputs, radios, checkboxes);
                };
            });

            function pushHistory() {
                const formData = new FormData(filtersForm);
                const formObj = [...formData.entries()]
                    .filter(val => !val.includes('search_terms') && !!val[1])
                    .reduce((acc, field) => {
                        const [key, value] = field;
                        if (acc.hasOwnProperty(key)) {
                            acc[key] = [...acc[key], value].join(',');
                            return { ...acc }
                        } else {
                            return { ...acc, [key]: value }
                        }
                    }, {});

                if (searchParams) {
                    const url = new URL(window.location);
                    url.search = new URLSearchParams(formObj);
                    history.pushState({}, '', url);
                }
            }

            function filterPosts(selects, inputs, radios, checkboxes, paged = 1, isLoadMoreClick = false) {
                pushHistory();

                const postsWrapper = document.getElementById('posts-wrapper');

                if (postsWrapper !== null) {
                    const action = postsWrapper.getAttribute('data-action');

                    fetch(cdScriptsObj.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Cache-Control': 'no-cache',
                        },
                        body: new URLSearchParams({
                            action: action,
                            selects: JSON.stringify(selects),
                            inputs: JSON.stringify(inputs),
                            radios: JSON.stringify(radios),
                            checkboxes: JSON.stringify(checkboxes),
                            paged: paged,
                            isLoadMoreClick: isLoadMoreClick,
                        }),
                    }).then(response => {
                        response.json().then(results => {
                            if (window.location.href.includes('?')) {
                                let onLoadHides = document.querySelectorAll('.hide-on-load');

                                onLoadHides.forEach(function (onLoadHide) {
                                    onLoadHide.classList.add('hide');
                                });
                            }

                            if (paged > 1) {
                                postsWrapper.innerHTML += results.cards;
                            } else {
                                postsWrapper.innerHTML = results.cards;
                            }

                            lozadInitiator.init();
                            animations.init();
                            modals.init();

                            loadMoreEls.forEach(function (loadMore) {
                                loadMore.setAttribute('data-next-page', results.paged);
                                loadMore.setAttribute('data-max-num-pages', results.max_num_pages);

                                if (results.paged > results.max_num_pages) {
                                    loadMore.classList.add('hide');
                                } else {
                                    loadMore.classList.remove('hide');
                                }
                            });
                        });
                    }).catch(err => console.log(err));
                }
            }

            function updateInputs(inputEls) {
                inputEls.forEach(function(input) {
                    const inputName = input.getAttribute('name');
                    inputs[inputName] = input.value;

                    input.oninput = throttle(function(evt){
                        inputs[inputName] = input.value;

                        if (input.value.length !== 1) {
                            filterPosts(selects, inputs, radios, checkboxes);
                        }
                    }, 500);
                });
            }

            function updateSelects(selectEls) {
                selectEls.forEach(function(select) {
                    const selectName = select.getAttribute('name');
                    selects[selectName] = select.value;

                    select.onchange = function(evt){
                        selects[selectName] = select.value;

                        filterPosts(selects, inputs, radios, checkboxes);
                    };
                });
            }

            function updateRadios(radioEls) {
                radioEls.forEach(function(radio) {
                    const radioName = radio.getAttribute('name');

                    if (radio.checked) {
                        radios[radioName] = radio.value;

                        showEventsFilters(radioName, radio.value);
                    }

                    radio.onchange = function(evt){
                        if (radio.checked) {
                            radios[radioName] = radio.value;

                            showEventsFilters(radioName, radio.value);
                        }

                        filterPosts(selects, inputs, radios, checkboxes);
                    };
                });
            }

            function updateCheckboxes(checkboxEls) {
                checkboxEls.forEach(function(checkbox) {
                    const checkboxName = checkbox.getAttribute('name');
                    checkboxes[checkboxName] = {};
                    checkboxes[checkboxName][checkbox.value] = checkbox.checked;

                    checkbox.onchange = function(evt){
                        checkboxes[checkboxName][checkbox.value] = checkbox.checked;

                        filterPosts(selects, inputs, radios, checkboxes);
                    };
                });
            }

            function initializeLoadMores(loadMoreEls) {
                loadMoreEls.forEach(function(loadMore) {
                    loadMore.onclick = function(evt){
                        filterPosts(selects, inputs, radios, checkboxes, loadMore.getAttribute('data-next-page'), true);
                    };
                });
            }

            function showEventsFilters(fieldName, fieldValue) {
                if (eventsFilters && fieldName === 'posttype') {
                    if (fieldValue === 'event') {
                        eventsFilters.classList.remove('hide');
                    } else {
                        eventsFilters.classList.add('hide');
                    }
                }
            }
        }
    }
}

archiveAjax.init();